<template>
  <span @click="toggleOpen">Фильтры</span>
</template>

<script>
export default {
  emits: ['toggle-sidemenu'],
  methods: {
    toggleOpen: function() { this.$emit('toggle-sidemenu'); },
  },
};

</script>
